module.exports = __webpack_public_path__ + "static/media/hive-animated.3978aad9.svg";